import React, { useEffect, useRef, useState } from "react";
import FormStrip from "../../components/FormStrip";
import HeaderContent from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { useTranslation } from "react-i18next";
import { PrimaryTabsWrapper, PrimaryTab, PrimaryTabs, SubTabsWrapper, SubTabs, SubTab, StyledDivider, PortalWrapper, SideWrapper, MainWrapper } from "../../components/StyledComponent";
import SubStep1 from "./Step1/SubStep1";
import SubStep2 from "./Step1/SubStep2";
import SubStep3 from "./Step1/SubStep3";
import SubStep4 from "./Step1/SubStep4";
import SubStep5 from "./Step1/SubStep5";
import getOwnerRegistrationData from "./getRegistrationData";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { Loader } from "@egovernments/digit-ui-react-components";
import Step2 from "./Step2";
import Step3 from "./Step3";
import ReactToPrint from "react-to-print";
import { Button, Card } from "@mui/material";
import TakeActionItem from "../../../../../../../templates/Forms/TakeActionItem";
import OwnerSummary from "./Step4";
import ButtonWrapper from "../../components/Button";
import { useHistory } from "react-router-dom";
import { citizenBaseUrl, Sidebarlabels } from "../../components/data";


const OwnerPortal = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId()
  const { id } = useParams();
  const history = useHistory()
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("OWNER_REGISTRATION_SUBTAB") || 0);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("OWNER_REGISTRATION_TAB") || 0);
  const { applicationData, isAppDataLoading } = getOwnerRegistrationData(id);
  const { info: userInfo } = Digit.UserService.getUser();
  const userUid = userInfo?.uuid;
  const Modal = useModal()
  const componentRef = useRef();

  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_OWNER_REGISTRATION", applicationData);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    }
    else if (key === "") {
      setParams({ ...data });
    }
    else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, 'OWNER_REGISTRATION');
  const approvedLayout = params?.approvedLayout === "no"
  const ownerOrApplicant = params?.ownerOrApplicant === 'Applicant'
  const subTabLabels = [
    { label: 'Basic Information' },
    { label: 'Owner Information' },
    { label: 'Applicant Information', show: ownerOrApplicant }, // Conditional tab
    { label: 'Registration Information' },
    { label: 'Bank Information (In case of Refund)' },
  ];

  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData }
      try {
        if (activeTab === 3) {
          data.workflow = approvedLayout ? { action: "FORWARD_TO_EXECUTIVE_ENGINEER", assignes: null } : { action: "FORWARD_TO_EMO", assignes: null }
        }
        else {
          data.workflow = { action: "UPLOAD_DOC", assignes: [userUid] };
        }
        console.log('updateApiCall before', data)
        updateApiCall.mutate({ ownerRegistration: data }, {
          onSuccess: () => {
            onSelect("", data);
            if(activeTab === 3){
              Modal(
                "Application Submitted.",
                `Your Application ${data?.applicationNo} Submitted Successfully!`,
                "success",
              );
              history.push(`${citizenBaseUrl}/profile`)
            } else{
              Modal(
                "Application updated.",
                `Application Updated Successfully!`,
                "success",
              );
            }
            setActiveTab(nextTabNo);
            Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo)
          },
          onError: () => {
            Modal("Update Error", "Something went wrong!!", "error")
          },
        })

      } catch (error) {
        console.error(e);
        Modal("Update Error", "Something went wrong!!", "error")
      }
    } else {
      setActiveTab(nextTabNo);
      Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo)
    }
  };
  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData }
      if ((activeTab === 0 && selectedSubTab === 0) && !('applicationNo' in params)) {
        Digit.OBPSService.createOwner({ ownerRegistration: data }, tenantId)
          .then((res) => {
            const result = res.ownerRegistration?.[0];
            if (res?.ownerRegistration?.length > 0) {
              onSelect("", { ...formData, ...result }, true);
              Modal(
                "Application created.",
                `Application Created Successfully!`,
                "success"
              );
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("OWNER_REGISTRATION_SUBTAB", nextSubTab)
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, 'error')
          });
      }
      else {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: [userUid] };
          console.log('updateApiCall before', data)
          updateApiCall.mutate({ ownerRegistration: data }, {
            onSuccess: () => {
              onSelect("", data);
              Modal(
                "Application updated.",
                `Application Updated Successfully!`,
                "success",
              );
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("OWNER_REGISTRATION_SUBTAB", nextSubTab)
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error")
            },
          })

        } catch (error) {
          console.error(e);
          Modal("Update Error", "Something went wrong!!", "error")
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("OWNER_REGISTRATION_SUBTAB", nextSubTab)
    }
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);
  
  const renderContent = () => {
    if (activeTab === 0) {
      if (ownerOrApplicant) {
        switch (selectedSubTab) {
          case 0:
            return <SubStep1 formData={params} handleSubTabChange={handleSubTabChange} />;
          case 1:
            return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} />;
          case 2:
            return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} />;
          case 3:
            return <SubStep4 formData={params} handleSubTabChange={handleSubTabChange} />;
          case 4:
            return <SubStep5 formData={params} handleTabChange={handleTabChange} />;
          default:
            return null;
        }
      } else {
        switch (selectedSubTab) {
          case 0:
            return <SubStep1 formData={params} handleSubTabChange={handleSubTabChange} />;
          case 1:
            return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} />;
          case 2:
            return <SubStep4 formData={params} handleSubTabChange={handleSubTabChange} />;
          case 4:
            return <SubStep5 formData={params} handleTabChange={handleTabChange} handleSubTabChange={handleSubTabChange} />;
          default:
            return null;
        }
      }

    } else if (activeTab === 1) {
      return <Step2 formData={params} handleTabChange={handleTabChange} />;
    } else if (activeTab === 2) {
      return <Step3 formData={params} handleTabChange={handleTabChange} />;
    } else if (activeTab === 3 && params?.applicationNo) {
      return <div>
        <ReactToPrint
          trigger={() => <button
            style={{
              backgroundColor: '#1f4a7c',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              position: 'absolute',
              right: '2rem'
            }}>Print Summary</button>}
          content={() => componentRef.current}
        />
        <Card style={{ width: '90%', margin: '0 auto' }} ref={componentRef}>
          <TakeActionItem
            formType={'OWNER_REGISTRATION'}
            id={params?.applicationNo}
            ref={componentRef}
          />
        </Card>
        <div className="footerContainer">
                <div className="buttonWrapper">
                    <ButtonWrapper
                        variant="contained"
                        color="error"
                        size="medium"
                        label="Preview"
                        sx={{ backgroundColor: '#CCC' }}
                        onClick={() => handleTabChange(0)}
                    />
                    <ButtonWrapper
                        variant="contained"
                        color="success"
                        size="medium"
                        label="Submit"
                        type="submit"
                        sx={{ backgroundColor: '#157CB3' }}
                        onClick={() => handleTabChange(3, params)}
                    />
                </div>
            </div>
      </div>;
    }
  };

  if (isAppDataLoading || (id && !applicationData)) {
    return <Loader />
  }
  return (
    <PortalWrapper>
      <SideWrapper>
        <Sidebar Sidebarlabels={Sidebarlabels}/>
      </SideWrapper>

      <MainWrapper>
        <HeaderContent />
        <FormStrip formName={"Owner Interface Form"} />
        <PrimaryTabsWrapper>
          {/* Tabs Header */}
          <PrimaryTabs
            value={activeTab}
            onChange={(e, i) => handleTabChange(i)}
            aria-label="Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            <PrimaryTab label="Applicant Information" />
            <PrimaryTab label="Map Information" />
            <PrimaryTab label="Documents" />
            <PrimaryTab label="Summary" />
          </PrimaryTabs>
        </PrimaryTabsWrapper>
        <StyledDivider />
        {activeTab === 0 && (
          <SubTabsWrapper>
            <SubTabs value={selectedSubTab} onChange={(e, i) => handleSubTabChange(i)} aria-label="Sub Tab Group" variant="scrollable" scrollButtons="auto">
              {subTabLabels
                .filter((tab) => tab.show !== false) // Only include tabs where `show` is true or undefined
                .map((tab, index) => (
                  <SubTab key={index} label={tab.label} />
                ))}
            </SubTabs>
          </SubTabsWrapper>
        )}
        {renderContent()}
      </MainWrapper>
    </PortalWrapper>
  );
};

export default OwnerPortal;
